import * as React from 'react';
import styles from './display-color.scss';

export interface DisplayColorProps {
  /**
   * hex color code
   */
  hexColor: string;
}

export const DisplayColor = (props: DisplayColorProps) => {    
        
    return (
      <div className={styles.displayColor} style={{backgroundColor:`${props.hexColor}`}}/>      
    );  
};
